let dropdown = document.querySelector('body.archive .filter-dropdown');
let dropdownToggle = document.querySelector('body.archive .filter-toggle');

// Filtering is a plain link to ?category=<slug>, handled server side. All this
// has left to do is open and close the mobile panel.
if(dropdownToggle) {
    dropdownToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown(!dropdown.classList.contains('show-ul'));
    });

    // The panel overlays the posts, so let a click or Escape anywhere dismiss it.
    document.addEventListener('click', function(e) {
        if(!dropdown.contains(e.target)) {
            toggleDropdown(false);
        }
    });

    document.addEventListener('keydown', function(e) {
        if(e.key == 'Escape' && dropdown.classList.contains('show-ul')) {
            toggleDropdown(false);
            dropdownToggle.focus();
        }
    });
}

function toggleDropdown(show) {
    if(!dropdown) {
        return;
    }
    dropdown.classList.toggle('show-ul', show);
    dropdownToggle.setAttribute('aria-expanded', show);
}
